import React from "react";
import ShuttleLayoutImage from "../img/shuttle-layout.png";
import { Table } from 'react-bootstrap';

export default class KeybindInformation extends React.Component {
    constructor (props) {
        super(props);

        this.state = { display: false };
    }

    render () {

        if (!this.state.display) {
            return (
                <div className="text-center">
                    <button className="btn btn-default" onClick={() => this.setState({display: true})}>
                        SHOW KEYBINDING INFO
                    </button>
                </div>
            );
        }

        return (
            <div>
                <h2>KEYBINDINGS</h2>

                <h3>Shuttle pro installation</h3>

                <div>
                    <ul className="text-left" style={{display: "inline-block"}}>
                        <li>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.contourdesign.com/support/drivers/">
                                Install "Shuttle Driver"
                            </a>
                        </li>
                        <li>
                            <a href={process.env.PUBLIC_URL + "/shuttle-pro-google-chrome-config.pref"}>
                                Download custom key mapping configuration
                            </a>
                        </li>
                        <li>
                            Open driver and import custom key mappings
                            <ul>
                                <li>
                                    Application Setting -> Select "Google Chrome" (or override Global Settings)
                                </li>
                                <li>
                                    Options -> Import Settings -> select downloaded config file
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <h3>Key mappings</h3>

                <img src={ShuttleLayoutImage} width="400px" height="auto" />

                <Table bordered>
                    <thead>
                        <tr>
                            <th>ShuttleKey</th>
                            <th>Keyboard</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th className="text-center" colSpan="3">Level 1</th>
                        </tr>
                        <tr>
                            <th>ShuttleWheel</th>
                            <th />
                            <th>Seeking</th>
                        </tr>
                        <tr>
                            <th>F1</th>
                            <th>1</th>
                            <th>Select upper-left tile</th>
                        </tr>
                        <tr>
                            <th>F2</th>
                            <th>2</th>
                            <th>Select upper-right tile</th>
                        </tr>
                        <tr>
                            <th>F3</th>
                            <th>3</th>
                            <th>Select lower-left tile</th>
                        </tr>
                        <tr>
                            <th>F4</th>
                            <th>4</th>
                            <th>Select lower-right tile</th>
                        </tr>
                        <tr>
                            <th>F5</th>
                            <th>5</th>
                            <th>Tag goal ( home team )</th>
                        </tr>
                        <tr>
                            <th>F6</th>
                            <th>6</th>
                            <th>Tag shots ( home team)</th>
                        </tr>
                        <tr>
                            <th>F7</th>
                            <th>7</th>
                            <th>Tag free kicks / offsides etc ( home team)</th>
                        </tr>
                        <tr>
                            <th>F8</th>
                            <th>8</th>
                            <th>Tag cards ( home team)</th>
                        </tr>
                        <tr>
                            <th>F9</th>
                            <th>9</th>
                            <th>Tag misc / major chance ( home team)</th>
                        </tr>
                        <tr>
                            <th>M1+F5</th>
                            <th>Shift+5</th>
                            <th>Tag goal ( away team )</th>
                        </tr>
                        <tr>
                            <th>M1+F6</th>
                            <th>Shift+6</th>
                            <th>Tag shots ( away team)</th>
                        </tr>
                        <tr>
                            <th>M1+F7</th>
                            <th>Shift+7</th>
                            <th>Tag free kicks / offsides etc ( away team)</th>
                        </tr>
                        <tr>
                            <th>M1+F8</th>
                            <th>Shift+8</th>
                            <th>Tag cards ( away team)</th>
                        </tr>
                        <tr>
                            <th>M1+F9</th>
                            <th>Shift+9</th>
                            <th>Tag misc / major chance ( away team)</th>
                        </tr>
                        <tr>
                            <th>M1+M2</th>
                            <th>Shift+x</th>
                            <th>Save tag (while exporting a new tag)</th>
                        </tr>
                        <tr>
                            <th>B1</th>
                            <th>space</th>
                            <th>Pause/Play</th>
                        </tr>
                        <tr>
                            <th>B2</th>
                            <th>b</th>
                            <th>Toggle auto-catchup (lets you force playback speed at 1x)</th>
                        </tr>
                        <tr>
                            <th>B3</th>
                            <th>n</th>
                            <th>Jump to live / reset</th>
                        </tr>
                        <tr>
                            <th>B4</th>
                            <th>m</th>
                            <th>Mute audio</th>
                        </tr>
                        <tr>
                            <th>-</th>
                            <th>z</th>
                            <th>Change possession to home team (top-left tile)</th>
                        </tr>
                        <tr>
                            <th>-</th>
                            <th>x</th>
                            <th>End possession (top-left tile)</th>
                        </tr>
                        <tr>
                            <th>-</th>
                            <th>c</th>
                            <th>Change possession to away team (top-left tile)</th>
                        </tr>
                        <tr>
                            <th>-</th>
                            <th>arrow-left</th>
                            <th>Change possession to home team (top-right tile)</th>
                        </tr>
                        <tr>
                            <th>-</th>
                            <th>arrow-down</th>
                            <th>End possession (top-right tile)</th>
                        </tr>
                        <tr>
                            <th>-</th>
                            <th>arrow-right</th>
                            <th>Change possession to away team (top-right tile)</th>
                        </tr>
                        <tr>
                            <th>-</th>
                            <th>Shift+z</th>
                            <th>Change possession to home team (bot-left tile)</th>
                        </tr>
                        <tr>
                            <th>-</th>
                            <th>Shift+x</th>
                            <th>End possession (bot-left tile)</th>
                        </tr>
                        <tr>
                            <th>-</th>
                            <th>Shift+c</th>
                            <th>Change possession to away team (bot-left tile)</th>
                        </tr>
                        <tr>
                            <th>-</th>
                            <th>Shift+arrow-left</th>
                            <th>Change possession to home team (bot-right tile)</th>
                        </tr>
                        <tr>
                            <th>-</th>
                            <th>Shift+arrow-down</th>
                            <th>End possession (bot-right tile)</th>
                        </tr>
                        <tr>
                            <th>-</th>
                            <th>Shift+arrow-right</th>
                            <th>Change possession to away team (bot-right tile)</th>
                        </tr>

                        <tr>
                            <th className="text-center" colSpan="3">Level 2</th>
                        </tr>

                        <tr>
                            <th>ShuttleWheel</th>
                            <th />
                            <th>Seeking</th>
                        </tr>
                        <tr>
                            <th>F1</th>
                            <th>1</th>
                            <th>Jump to start of clip (green marker)</th>
                        </tr>
                        <tr>
                            <th>F2</th>
                            <th>2</th>
                            <th>Jump to event-time (yellow marker)</th>
                        </tr>
                        <tr>
                            <th>F3</th>
                            <th>3</th>
                            <th>Jump to end of clip (red marker)</th>
                        </tr>
                        <tr>
                            <th>M1+F1</th>
                            <th>Shift+1</th>
                            <th>Set start of clip (green marker)</th>
                        </tr>
                        <tr>
                            <th>M1+F2</th>
                            <th>Shift+2</th>
                            <th>Set event-time (yellow marker)</th>
                        </tr>
                        <tr>
                            <th>M1+F3</th>
                            <th>Shift+3</th>
                            <th>Set end of clip (red marker)</th>
                        </tr>
                        <tr>
                            <th>F5</th>
                            <th>5</th>
                            <th>Set playback rate (0.2x)</th>
                        </tr>
                        <tr>
                            <th>F6</th>
                            <th>6</th>
                            <th>Set playback rate (0.5x)</th>
                        </tr>
                        <tr>
                            <th>F7</th>
                            <th>7</th>
                            <th>Set playback rate (1.0x)</th>
                        </tr>
                        <tr>
                            <th>F8</th>
                            <th>8</th>
                            <th>Set playback rate (3.0x)</th>
                        </tr>
                        <tr>
                            <th>F9</th>
                            <th>9</th>
                            <th>Set playback rate (6.0x)</th>
                        </tr>
                        <tr>
                            <th>B1</th>
                            <th>space</th>
                            <th>Pause/Play</th>
                        </tr>
                    </tbody>
                </Table>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/KeybindInformation.js